import { createPostAsyncSlice } from '@sonar-software/xuder';
import { postLockAllCustomerUsers } from '../../../../api';

export const adminCustomersLockAllUsersPostSlice = createPostAsyncSlice({
	name: 'AdminCustomersLockAllUsers',
	receive: true,
	request: true,
	requestHandler: postLockAllCustomerUsers,
	retainDataOnRequest: false
});
